<div class="lot-search-container" data-testid="cm-lot-search-container">
  @if (isOnline === false) {
    <app-search-offline
      title="Search is Offline"
      subtitle="You can still see the lots on your list, but you'll need an internet connection to search and add new ones.">
    </app-search-offline>
  } @else {

    @if (step() === "division") {
      <div class="picker-view" data-testid="cm-lot-search-picker-division">
        <div class="picker-header">
          <button
            type="button"
            class="icon-button close-button"
            (click)="closeSheet()"
            aria-label="Close"
            data-testid="cm-lot-search-btn-close-division">
            ×
          </button>

          <div class="picker-title">Select Division</div>
          <div class="header-spacer"></div>
        </div>

        <div class="picker-list" data-testid="cm-lot-search-list-divisions">
          @if (loadingDivisions) {
            <div class="picker-loading">Loading Divisions...</div>
          } @else {
            @for (division of divisions(); track division.id) {
              <button
                type="button"
                class="picker-row"
                [class.selected]="selectedDivision()?.id === division.id"
                (click)="onDivisionSelected(division)"
                data-testid="cm-lot-search-btn-division-item">
                <span class="radio-circle">
                  @if (selectedDivision()?.id === division.id) {
                    <span class="radio-dot"></span>
                  }
                </span>

                <span class="picker-row-label">{{ division.name }}</span>
              </button>
            }
          }
        </div>
      </div>
    }

    @if (step() === "community") {
      <div class="picker-view" data-testid="cm-lot-search-picker-community">
        <div class="picker-header">
          <button
            type="button"
            class="icon-button back-button"
            (click)="backFromCommunity()"
            aria-label="Back"
            data-testid="cm-lot-search-btn-back-community">
            ←
          </button>

          <div class="picker-title">Select Community</div>
          <div class="header-spacer"></div>
        </div>

        <div class="drawer-search-input">
          <input
            type="text"
            pInputText
            placeholder="Search for Community"
            [(ngModel)]="communitySearchTerm"
            (ngModelChange)="onDrawerSearchTermChange($event)"
            data-testid="cm-lot-search-input-community" />
        </div>

        <div class="picker-list" data-testid="cm-lot-search-list-communities">
          @for (community of drawerCommunityResults(); track community.externalSalesCommunityId) {
            <button
              type="button"
              class="picker-row"
              [class.selected]="drawerSelectedCommunity?.externalSalesCommunityId === community.externalSalesCommunityId"
              (click)="onCommunityRowClick(community)"
              data-testid="cm-lot-search-btn-community-item">
              <span class="radio-circle">
                @if (drawerSelectedCommunity?.externalSalesCommunityId === community.externalSalesCommunityId) {
                  <span class="radio-dot"></span>
                }
              </span>

              <span class="picker-row-label">{{ community.salesCommunityName }}</span>
            </button>
          }
        </div>
      </div>
    }

    @if (step() === "search") {
      <div class="search-view" data-testid="cm-lot-search-search-view">
        <div class="search-header">
          <button
            type="button"
            class="icon-button back-button"
            (click)="backFromSearch()"
            aria-label="Back"
            data-testid="cm-lot-search-btn-back-search">
            ←
          </button>

          <div class="search-title">
            {{ selectedCommunity()?.salesCommunityName ?? "Find a Lot" }}
          </div>

          <button
            type="button"
            class="icon-button close-button"
            (click)="closeSheet()"
            aria-label="Close"
            data-testid="cm-lot-search-btn-close-search">
            ×
          </button>
        </div>

        <lot-search-component
          [fromCMSearch]="true"
          [selectedCommunity]="selectedCommunity"
          [communities]="communities"
          [searchTerm]="searchTerm"
          (searchCommunityHandler)="backFromResults()"
          (backButtonPress)="backFromResults()"
          (done)="closeSheet()">
        </lot-search-component>
      </div>
    }
  }
</div>
